const filters = document.querySelector("[data-filters]")

const getFilterData = (filterElements) => {
  let obj = {},
    checked,
    checkedValues;

  filterElements.forEach((target, index) => {
    const { type, name, value } = target;

    // Check if the keyword field is selected, then reset the category dropdown
    if (name === 'keywords' && value.trim() !== '') {
      const categorySelect = document.querySelector(
        'select[name="categories"]'
      );
      if (categorySelect) {
        categorySelect.selectedIndex = 0;
        updateURLParam('categories', '');
      }
      updateURLParam('keywords', value.trim());
    }

    // Check if the category is selected, then clear the keyword input
    if (name === 'categories' && value !== '') {
      const keywordInput = document.querySelector('input[name="keywords"]');
      if (keywordInput) {
        // keywordInput.value = '';
        updateURLParam('keywords', null);
      }
    }

    if (type == 'radio' || type == 'checkbox') {
      if (!obj[name]) {
        checked = filters.querySelectorAll(`input[name='${name}']:checked`);
        checkedValues = [];
        checked.forEach((c) => {
          checkedValues.push(c.value);
        });

        obj = {
          ...obj,
          [name]: checkedValues.join(','),
        };
      }
    } else {
      obj = {
        ...obj,
        [name]: value,
      };
    }
  });
  return obj;
};

function updateURLParam(param, value) {
  const url = new URL(window.location);
  url.searchParams.set(param, value ?? '');

  window.history.replaceState({}, '', url);
}

// Convert object to query string helper
const obj2QueryString = (obj) => {
  return Object.keys(obj)
    .map((key) => {
      let val = obj[key].split(',');
      if (val.length > 1) {
        console.log(val);
        return val
          .map((v) => {
            return encodeURIComponent(key) + '=' + v;
          })
          .join('&');
      } else {
        return encodeURIComponent(key) + '=' + val[0];
      }
    })
    .join('&');
};
const queryString2Obj = (str) => {
  if (!str.length) return {};
  const arr = str.split('&');
  const obj = arr.reduce((o, v) => {
    o[v.split('=')[0]] = v.split('=')[1];
    return o;
  }, {});
  return obj;
};

// Ajax new content, and replace existing content
const getContent = (filterElements) => {
  const data = getFilterData(filterElements);
  const objQ = queryString2Obj(location.search.substr(1));
  const newQ = obj2QueryString(data);

  // Show a loader
  const oldListingContainer = document.querySelector('[data-filtered-content]');
  const loader = document.createElement('div');
  loader.setAttribute('class', 'loader');
  oldListingContainer.prepend(loader);

  // Update current filters
  const newLocation = location.origin + location.pathname + '?' + newQ;

  fetch(newLocation)
    .then((response) => {
      history.pushState('', '', newLocation);
      return response.text();
    })
    .then((data) => {
      const parser = new DOMParser();
      const htmlResponse = parser.parseFromString(data, 'text/html');
      const newListingContainer = htmlResponse.documentElement.querySelector(
        '[data-filtered-content]'
      );
      oldListingContainer.innerHTML = newListingContainer.innerHTML;
      console.log('done');
    })
    .catch((error) => {
      console.log('🤡');
      console.log(error);
    });
};

// Loop through provided elements and init listeners and prevent default on form to maintain query
const initListeners = (filterElements) => {
  Array.prototype.forEach.call(filterElements, (element) => {
    element.addEventListener(
      'change',
      (event) => {
        getContent(filterElements);
      },
      false
    );
  });

  document.body.addEventListener('click', function (event) {
    if (event.target.dataset.filtersUpdate != undefined) {
      getContent(filterElements);
    }
  });
};

const initFilters = (filters) => {
  if (!filters) {
    return;
  }

  // Check for filters inside our wrapper
  const filterElements = filters.querySelectorAll(`select, input`);

  if (!filterElements.length) {
    return;
  }

  // Get current filters
  getFilterData(filterElements);

  // Create listeners for each select, and fire ajax function
  initListeners(filterElements);
};

initFilters(filters)
